<template>
  <Dropdown
    class-name="session-participants"
    :title="t('session.participants.title')"
    :default-open="false"
    :is-loaded="!isPendingRef"
  >
    <template v-if="mentorRef">
      <UserCard
        v-for="user in [mentorRef, ...menteesRef]"
        :key="user.id"
        :user="user"
        :status="
          !isPresencesEmptyRef
            ? user.roles?.includes(RoleEnumTypeV2.MENTOR)
              ? SessionStatusEnumType.FINISHED
              : sessionRef?.presences.find((presence) => presence.userId === user?.id)?.wasPresent
                ? SessionStatusEnumType.FINISHED
                : SessionStatusEnumType.CANCELLED
            : undefined
        "
      />
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { RoleEnumTypeV2 } from '@/features/auth/types'
import { getMentees, getMentor } from '@/features/groups/utils'
import useSession from '@/features/sessions/hooks/use-session.hook'
import { SessionStatusEnumType } from '@/features/sessions/types'
import Dropdown from '@/features/ui/components/dropdown/dropdown.vue'
import { selectGetSessionDetailsModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'
import UserCard from '@/features/users/components/user-card/user-card.vue'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()

const sessionDetailsModalRef = selectGetSessionDetailsModal(modalsStore)

const sessionIdRef = computed(() => sessionDetailsModalRef.value.attachedData.sessionId ?? null)

const { sessionRef, isPendingRef } = useSession(sessionIdRef)

const menteesRef = computed(() => sessionRef.value?.users.filter(getMentees) ?? [])

const mentorRef = computed(() => sessionRef.value?.users.find(getMentor))

const isPresencesEmptyRef = computed(
  () => sessionRef.value?.presences.length === 0 || sessionRef.value?.presences === undefined,
)
</script>

<style lang="scss">
@import './session-participants.scss';
</style>
